import { DvmExamOutput } from 'gql/types';
import { useModal } from 'modules/common/hooks';
import { useState } from 'react';

export const useDvmExamModal = () => {
  const modal = useModal();
  const [selectedDvmExam, setSelectedDvmExam] = useState<
    DvmExamOutput | undefined
  >();

  const openForCreate = () => {
    setSelectedDvmExam(undefined);
    modal.show();
  };

  const openForEdit = (dvmExam: DvmExamOutput) => {
    setSelectedDvmExam(dvmExam);
    modal.show();
  };

  const close = () => {
    modal.hide();
    setSelectedDvmExam(undefined);
  };

  return {
    modalConfig: modal.config,
    selectedDvmExam,
    openForCreate,
    openForEdit,
    close,
  };
};
